import PersonItem from "./personItem";

type iOrganizationType= Readonly<"PERSON" | "DEPARTMENT" | "ZONE"| "GRADE"| "PHYSICALCLAZZ"| "TEACHINGCLAZZ">
type iViewSubItems= Readonly<PersonItem | Organization>

export default class Organization {
    /**
     * 组织ID
     */
    public id: string;
    /**
     * 组织名称
     */
    public name: string;
    /**
     * 组选择器，选择策略
     */
    public selectType: string;
    /**
     * 用户编号，学生学号，教职工编号
     */
    public no: string;
    /**
     * 组织所包含用户数量
     */
    public personNumber: number;
    /**
     * 组织类型
     */
    public organizationType: iOrganizationType;
    /**
     * 下属部门
     */
    public subItems: Organization[];
     /**
     * 上级部门，如为顶级部门，则parentID为空
     */
    public parentId: string;
    public viewSubItems: iViewSubItems [];
   
    constructor({ 
        id = '', 
        parentId = '', 
        name = '', 
        selectType = '', 
        no = '', 
        personNumber = 0, 
        organizationType = '', 
        subItems = [], 
        viewSubItems=[]
    } = {}) {
        this.id=`${id}`;
        this.parentId=parentId;
        this.name=name;
        this.selectType=selectType;
        this.no=no;
        this.personNumber=personNumber;
        this.organizationType=organizationType as iOrganizationType;
        this.subItems=subItems||[];
        this.viewSubItems=viewSubItems||[];
    }
}